import { createApi } from '@reduxjs/toolkit/query/react';

import {
  DaDataEndpoints as Endpoints,
  type ListCitiesByEntryRequest,
  type ListCitiesByEntryResponse,
} from '@app/api/DaData/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { DADATA_CHUNK } from '@app/constants';

export const dadataApi = createApi({
  reducerPath: 'dadataApi',
  baseQuery: createApiBaseQuery(DADATA_CHUNK),
  endpoints: ({ query }) => ({
    [Endpoints.ListCitiesByEntry]: query<
      ListCitiesByEntryResponse,
      ListCitiesByEntryRequest
    >({
      query: (params) => ({
        url: Endpoints.ListCitiesByEntry,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const { useListCitiesByEntryQuery, useLazyListCitiesByEntryQuery } =
  dadataApi;
